import { Outlet, useNavigate, Navigate } from "react-router-dom";

function ProtectedRoutes() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  return token ? (
    <>
      <div className="bg-zinc-700 text-slate-100 py-3 px-32 flex justify-between md:px-12">
        <button
          className="font-bold text-xl"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          flashcards
        </button>{" "}
        <button
          className="text-white bg-amber-400 border-neutral-50 rounded p-2 hover:bg-amber-500"
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/login");
          }}
        >
          Sign Out
        </button>{" "}
      </div>
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
}

export default ProtectedRoutes;
